import React, { createContext, useMemo } from "react";

/**
 * This provider is meant to allow all pallet components to use the localization mechanism provided
 * by the application; the goal fow now is to leave `i18n` out of the dependency tree for pallet, by
 * keeping both the amount of localized text in our components here small (e.g use `label` attributes)
 * and making the contract for localized text a simple `string -> string` function.
 */

type PalletLangContextInterface = {
  simpleTranslate: (key: string) => string;
};

export const PalletLangContext =
  createContext<PalletLangContextInterface | null>(null);

export function PalletLangProvider({
  children,
  simpleTranslate,
}: {
  simpleTranslate: (key: string) => string;
  children: React.ReactNode;
}) {
  const contextImpl = useMemo<PalletLangContextInterface>(
    () => ({ simpleTranslate }),
    [simpleTranslate],
  );

  return (
    <PalletLangContext.Provider value={contextImpl}>
      {children}
    </PalletLangContext.Provider>
  );
}
